import React from 'react';
import Modal from 'react-bootstrap/Modal';

import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

function PaymentSuccessModal({ onClose }) {
  return (
    <>
      <Modal
        show
        onHide={onClose}
      >
        <Modal.Header>
          <h3>Payment Complete</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="col">Your payment has been processed successfully.</div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

PaymentSuccessModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default PaymentSuccessModal;
